// extracted by mini-css-extract-plugin
export default {"wrapperPage":"Services_wrapperPage__tQ-jk","title":"Services_title__B8uSa","content":"Services_content__5A6-E"};